import React from 'react'
import tw from 'tailwind-styled-components'
import {Hub} from 'yougile-model'
import {Icon} from '@components/common/base/icon'

// max-w-full
const TwPath = tw.div`
  flex
  flex-wrap
  gap-4
  items-center
`

const TwPathItem = tw.div`
  [max-width:calc(100%-24px)]
  inline-block
  flex-initial
  text-xs-regular
  text-icon-secondary
  overflow-hidden
  text-ellipsis
  text-no-wrap
`

interface MirrorColumnPathProps {
  items: Hub[]
  className?: string
}

export const MirrorColumnPath = ({items, className}: MirrorColumnPathProps) => (
  <TwPath className={className}>
    {items.reduce((acc, x, i) => {
      i &&
        acc.push(
          <Icon key={i} icon="IconChevronRight" size={16} color="secondary" />
        )
      // prevent path items key collision by adding an index to the key
      acc.push(<TwPathItem key={x.title + '-' + i}>{x.title}</TwPathItem>)
      return acc
    }, [] as React.ReactNode[])}
  </TwPath>
)
